import { SxProps, Theme } from '@mui/material/styles';

export const headerTitleSx: SxProps<Theme> = { fontWeight: 600, fontSize: '0.875rem' };

export const iconButtonSx: SxProps<Theme> = { padding: 0 };

export const deleteMenuItemSx: SxProps<Theme> = { color: 'error.main' };

export const deleteIconSx: SxProps<Theme> = { mr: 1 };

export const documentInfoStackSx: SxProps<Theme> = { py: 0.5 };

export const documentInfoTextSx: SxProps<Theme> = { fontSize: '0.875rem', color: 'text.primary' };

export const citationTextBoxSx: SxProps<Theme> = { py: 0.5 };

export const citationTextSx: SxProps<Theme> = {
  fontSize: '0.875rem',
  color: 'text.primary',
  fontStyle: 'italic',
};

export const dividerSx: SxProps<Theme> = { mt: 1 };

export const footerCaptionSx: SxProps<Theme> = {
  fontSize: '0.75rem',
  color: 'text.secondary',
  pt: 0.5,
};
